'use strict';

/*
 * videoTracking.js -- Release 2 watch page events (specs/005-video-library, contracts/analytics-events.md).
 *
 * GA4 (gtag only exists on www.proworks.com) and Umbraco Engage (every environment), both guarded, following
 * homeHeroCta.js. Engage category "Video"; report on it rather than Engage's name-only "GA 4 - Bridging" copy.
 *
 *   video_cta_click    a click on the call to action (.video-cta a)
 *                      video_id, link_url, link_text          Engage "CTA click" / video_id
 *   video_more_click   a click on a More videos card (.video-more .video-card a)
 *                      video_id (this page), target_video_id  Engage "More videos click" / target_video_id
 *   h5yr_engage        the first move into the H5YR widget (h5yrEngaged, from h5yrEngagement.js via videopage.js)
 *                      video_id, video_title                  Engage "High 5 widget" / video_id
 *   video_filter       a /videos/ load with a newly applied topic filter (initListing, from videolibrary.js);
 *                      paging or reloading the same topic isn't reported again (sessionStorage pw.videoFilter)
 *                      topic                                  Engage "Filter" / topic
 *
 * video_id is `{platform}:{id}` from the player's data-video-id; target_video_id comes from the card's own
 * data-video-id. One delegated listener, so neither call blocks or delays the navigation. The filter values come
 * from the server (data-active-topic on .video-filters), so only a filter the listing applied is reported.
 */

function currentVideoId() {
    var player = document.querySelector('.video-page .video-player');
    return player ? player.getAttribute('data-video-id') || '' : '';
}

function send(eventName, params, engageAction, engageLabel) {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
    }

    if (typeof window.umbEngage === 'function') {
        window.umbEngage('send', 'event', 'Video', engageAction, engageLabel);
    }
}

function onClick(e) {
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) {
        return;
    }

    var videoId = currentVideoId();

    if (link.closest('.video-cta')) {
        send('video_cta_click', {
            video_id: videoId,
            link_url: link.getAttribute('href') || '',
            link_text: (link.textContent || '').trim()
        }, 'CTA click', videoId);
        return;
    }

    var card = link.closest('.video-more .video-card');
    if (card) {
        var targetVideoId = card.getAttribute('data-video-id') || '';
        send('video_more_click', {
            video_id: videoId,
            target_video_id: targetVideoId
        }, 'More videos click', targetVideoId);
    }
}

function init() {
    document.addEventListener('click', onClick);
}

function h5yrEngaged() {
    var player = document.querySelector('.video-page .video-player');
    var videoId = currentVideoId();
    send('h5yr_engage', {
        video_id: videoId,
        video_title: player ? player.getAttribute('data-video-title') || '' : ''
    }, 'High 5 widget', videoId);
}

// The last topic reported this session, so paging through or reloading a filtered listing reports it once. An
// unfiltered load clears it, so choosing the same topic again later counts again.
var FILTER_KEY = 'pw.videoFilter';

function readStoredFilter() {
    try {
        return window.sessionStorage.getItem(FILTER_KEY) || '';
    } catch (err) {
        return '';
    }
}

function storeFilter(topic) {
    try {
        if (topic) {
            window.sessionStorage.setItem(FILTER_KEY, topic);
        } else {
            window.sessionStorage.removeItem(FILTER_KEY);
        }
    } catch (err) {
        // Storage blocked: every filtered load is reported, which only over-counts.
    }
}

function initListing() {
    var form = document.querySelector('.video-filters');
    var topic = form ? form.getAttribute('data-active-topic') || '' : '';
    if (topic && topic !== readStoredFilter()) {
        send('video_filter', { topic: topic }, 'Filter', topic);
    }
    storeFilter(topic);
}

module.exports = { init: init, initListing: initListing, h5yrEngaged: h5yrEngaged, send: send, currentVideoId: currentVideoId };
